module.exports = "/api/cdn/public/static-assets/images/f58ff42c7adc6e014b696a713af78a79.png";